angular.module('rjmNg.controllers').controller 'searchCtrl', [
  "$scope"
  "dashboardService"
  "Trend"
  "Charts"
  "app"
  "appRoute"
  "stringService"
  "$clientAppUrl"
  (
    $scope
    dashboardService
    Trend
    Charts
    app
    appRoute
    stringService
    $clientAppUrl
  ) ->

  #search stuff
    $scope.trends = Trend.getMetalist(clientId: app.getClientId())
    charts = []
    Charts.getCharts().then (chartList) -> charts = chartList
    $scope.chartMatches = []
    $scope.trendMatches = []
    $scope.dashboardMatches = []
    $scope.noResults = false
    $scope.dashboard = dashboardService.dashboard
    $scope.query = ""

    getFormattedDashboards = () ->
      app.getDashboards().map((dashboard) ->
          clientId: dashboard.clientId
          type: 'Dashboard'
          id: dashboard.id
          searchKey: dashboard.name
          action: 'View'
          name: dashboard.name
          group: dashboard.group
          userName: dashboard.userName
          href: $clientAppUrl("/#{dashboard.id}")
          isSyndicated: dashboard.is_syndicated
          isActive: dashboardService.dashboard?.id is dashboard.id
          isDefault: dashboard.is_default
      )

    getDashboardsByGroup = () ->
      dashboardsObj = getFormattedDashboards()
      .reduce((acc, dashboard) ->
        myGroup = dashboard.group
        if myGroup is 'UNGROUPED'
          myGroup = 'No Group'

        if acc[myGroup]?
          acc[myGroup].dashboards.push dashboard
        else
          acc[myGroup] = {
            expanded: true,
            dashboards: [dashboard]
          }
        acc
      ,
        {'No Group':
          dashboards: []
          expanded: true} # put ungrouped dashboards first
      )
      dKeys = _.keys(dashboardsObj)
      dVals = _.values(dashboardsObj)
      _.object(dKeys.reverse(), dVals.reverse())

    $scope.canBrowseDashboards = app.hasFeatureFlag('DASHBOARD_DISCOVERY')

    $scope.$on "dashboardReady", () ->
      $scope.dashboard = dashboardService.dashboard
      $scope.dashboardMatches = buildDashboardSearchList("")
      $scope.dashboardsByGroup = getDashboardsByGroup()

    $scope.$on "updateGlobalSearch", () ->
      $scope.dashboardMatches = buildDashboardSearchList("")
      $scope.dashboardsByGroup = getDashboardsByGroup()

    $scope.search = () ->
      query = stringService.escapeRegEx($scope.query)
      if query isnt ""
        $scope.chartMatches = buildChartSearchList(query)
        trendMatches = buildTrendSearchList(query)
        $scope.trendMatches = trendMatches
      else
        $scope.chartMatches = []
        $scope.trendMatches = []

      $scope.dashboardsByGroup = getDashboardsByGroup()
      $scope.dashboardMatches = buildDashboardSearchList(query)

      $scope.noResults = $scope.dashboardMatches.length is 0 and $scope.chartMatches.length is 0 and $scope.trendMatches.length is 0

    buildDashboardSearchList = (query) =>
      dashMatches = []

      for dashboard in getFormattedDashboards()
        if dashboard.name.match(new RegExp(query, "i")) and +dashboard.clientId is +app.getClientId()
          dashMatches.push dashboard

      return dashMatches

    $scope.dashboardsByGroup = getDashboardsByGroup()
    $scope.dashboardMatches = buildDashboardSearchList("")

    buildTrendSearchList = (query) =>
      trendMatches = []

      if app.isReadOnlyUser()
        return trendMatches

      for trend in $scope.trends
        if trendMatches.length is 5
          break
        if trend.name.match(new RegExp(query, "i"))
          trendMatches.push
            type: 'Trend'
            id: trend.id
            searchKey: trend.name
            action: "Edit"
            name: trend.name
            href: appRoute('/settings/metric/edit/' + trend.id)

      return trendMatches

    buildChartSearchList = (query) =>
      dashboardItemMatches = []

      for chart in charts
        if dashboardItemMatches.length is 10
          break

        if chart.name.match(new RegExp(query, "i"))
          dashboardItemTempMatches = []

          if chart.dashboardItems.length > 0
            dashboardItem = chart.dashboardItems[0]
            dashboardItemTempMatches.push
              type: 'Dashboard'
              id: dashboardItem.id
              searchKey: chart.name
              action: "View"
              name: getDashboardNameById(dashboardItem.dashboardId)
              href: $clientAppUrl("/#{dashboardItem.dashboardId}##{dashboardItem.id}")

          dashboardItemMatches = dashboardItemMatches.concat(dashboardItemTempMatches)

      return dashboardItemMatches

    getDashboardNameById = (did) =>
      for dashboard in app.getDashboards()
        if dashboard.id is did
          return dashboard.name

  ]
